<template>
  <div ref="setH">
    <div class="manageBox">
      <div class="shrink">
        <div class="bg1" :class="shrink ? '' : 'on'" style="min-height: 0px">
          <div class="shrinkRight">
            <el-button
              type="primary"
              @click="
                shrink = true;
                getUploadList();
              "
              size="small"
              style="margin-left: 74px"
              >查询</el-button
            >
            <el-button
              plain
              @click="
                conditions1.nianjiList = [];
                conditions1.banbenList = [];
                conditions1.ceciList = [];

                search = {
                  approvalSchoolId: '',
                  orgName: '',
                  userName: '',
                  year: '',
                  beginDate: '',
                  endDate: '',
                  sectionId: '',
                  subjectId: '',
                  versionId: '',
                  gradeId: '',
                  volumeId: '',
                  relationDataId: '',
                  dataId: '',
                  chapterId: '',
                  resourceTypeId: '',
                  fileType: '',
                  resourceName: '',
                  firstChapterId: '',
                  secondChapterId: '',
                  thirdChapterId: '',
                  fourthChapterId: '',
                  shareSystem: '',
                  recordType: '',
                  userId: '',
                  favoriteDownUserId: '',
                  schoolId: '',
                  startTime: '',
                  endTime: '',
                  page: 1,
                  size: 10,
                  catalog: [],
                  firstChapterId: '',
                  secondChapterId: '',
                  thirdChapterId: '',
                  fourthChapterId: '',
                };
              "
              size="small"
              >重置</el-button
            >
            <el-button
              size="small"
              :icon="shrink ? 'el-icon-arrow-left' : 'el-icon-arrow-down'"
              class="shrinkButton"
              @click="shrink = !shrink"
            ></el-button>
          </div>
          <div class="searchBox">
            <ul>
              <li>
                <em>资源名称：</em>
                <el-input
                  v-model="search.resourceName"
                  size="small"
                  style="width: 250px"
                  placeholder="请输入内容"
                ></el-input>
              </li>
              <li>
                <em>选择学段：</em>
                <el-select
                  v-model="search.sectionId"
                  placeholder="选择学段"
                  style="width: 250px"
                  size="small"
                  clearable
                  @change="selSection(search, conditions1)"
                >
                  <el-option
                    v-for="item in conditions1.xueduanList"
                    :key="item.node"
                    :label="item.text"
                    :value="item.node"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <em>选择年级：</em>
                <!-- 选择年级 -->
                <el-select
                  v-model="search.gradeId"
                  placeholder="选择年级"
                  style="width: 250px"
                  size="small"
                  clearable
                  @change="selGrade(search, conditions1)"
                >
                  <el-option
                    v-for="item in conditions1.nianjiList"
                    :key="item.node"
                    :label="item.text"
                    :value="item.node"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <em>选择学科：</em>
                <el-select
                  v-model="search.subjectId"
                  placeholder="选择学科"
                  style="width: 250px"
                  size="small"
                  clearable
                  @change="selSubject(search, conditions1)"
                >
                  <el-option
                    v-for="item in conditions1.xuekeList"
                    :key="item.node"
                    :label="item.text"
                    :value="item.node"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <em>选择目录：</em>
                <el-cascader
                  v-model="search.catalog"
                  @change="handleChange"
                  :options="
                    sectionData.filter((el) => el.id == search.sectionId)[0]
                      ? sectionData
                          .filter((el) => el.id == search.sectionId)[0]
                          .children.filter((el) => el.id == search.subjectId)[0]
                        ? sectionData
                            .filter((el) => el.id == search.sectionId)[0]
                            .children.filter((el) => el.id == search.subjectId)[0]
                            .children
                        : []
                      : []
                  "
                  :props="props"
                  size="small"
                  style="width: 250px"
                ></el-cascader>
              </li>
              <li>
                <em>资源类型：</em>
                <div style="display: inline-block; width: 830px">
                  <el-radio-group v-model="search.resourceTypeId" size="small">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button
                      v-for="(item, i) in conditions.ziyuanleibieList"
                      :key="'resource' + i"
                      :label="item.code"
                      >{{ item.name }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </li>
              <li>
                <em>文档类型：</em>
                <div style="display: inline-block; width: 830px">
                  <el-radio-group v-model="search.fileType" size="small">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button
                      v-for="(item, i) in conditions.wendangleixingList"
                      :key="'resource' + i"
                      :label="item.key"
                      >{{ item.value }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </li>
              <li>
                <em>共享状态：</em>
                <el-select
                  v-model="search.shareSystem"
                  placeholder="共享状态"
                  style="width: 250px"
                  size="small"
                  clearable
                >
                  <el-option label="未共享" :value="-1"></el-option>
                  <el-option label="审核中" :value="0"></el-option>
                  <el-option label="已共享" :value="1"></el-option>
                  <el-option label="已拒绝" :value="2"></el-option>
                </el-select>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bg1" style="">
        <div class="contentBox">
          <div class="bd ys4" style="min-height: 520px">
            <ul v-if="tableData.length > 0">
              <li
                v-for="(d, i) in tableData"
                :key="i"
                style="height: auto; overflow: hidden"
              >
                <div class="icon">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#icontbd' + d.fileType"></use>
                  </svg>
                  <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                    >- {{ d.filePage }}页 -</em
                  >
                </div>
                <div class="title">
                  <h5 @click="yulan(d, 1)">{{ d.resourceName }}</h5>
                  <span class="catalog">
                    <i class="ka">{{ d.resourceTypeName }}</i>
                    <i v-if="d.versionName">{{ d.versionName }}</i>
                    <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                    <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                    <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                    <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                    <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
                    <!-- <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                  <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i> -->
                  </span>
                  <span class="attribute">时间：{{ d.createTime.split(" ")[0] }}</span>
                  <span class="attribute">浏览量：{{ d.visitedNumber }}</span>
                  <!-- <span class="download">下载量：{{ d.downloadNumber }}</span> -->
                  <span class="attribute">收藏量：{{ d.favoriteNumber }}</span>
                  <span class="attribute">下载量：{{ d.downloadNumber }}</span>
                  <span class="attribute">大小：{{ unit(d.fileSize) }}</span>
                  <span class="attribute"
                    >共享状态：
                    <em v-if="d.shareSystem == '-1'">未共享</em>
                    <em v-if="d.shareSystem == '0'" class="blue">审核中</em>
                    <em v-if="d.shareSystem == '1'" class="green">已共享</em>
                    <em v-if="d.shareSystem == '2'" class="red">已拒绝</em></span
                  >
                  <!-- <span class="school">学校：{{ d.schoolName }}</span>
                <span class="author">作者：{{ d.createUserName }}</span> -->
                </div>
                <div class="operate">
                  <el-button
                    type="primary"
                    @click="downLoad(d, 1)"
                    :disabled="d.fileUrl == '' || d.fileUrl == null"
                    size="small"
                    >下载</el-button
                  >
                  <el-button
                    type="text"
                    v-if="d.shareSystem == -1"
                    @click="gongxiang(d)"
                    size="small"
                    style="padding: 2px 15px"
                    >共享</el-button
                  >

                  <el-button
                    type="text"
                    v-if="d.shareSystem == -1 || d.shareSystem == 1"
                    @click="bianjishuxing(d)"
                    size="small"
                    style="padding: 2px 15px"
                    >编辑属性</el-button
                  >

                  <!-- <el-button
                    type="text"
                    v-if="d.shareSystem == 2"
                    @click="chongxinshangchuan(d)"
                    size="small"
                    style="padding: 2px 15px"
                    >重新上传</el-button
                  > -->
                  <el-button
                    type="text"
                    v-if="d.shareSystem == 2"
                    @click="chakan(d)"
                    size="small"
                    style="padding: 2px 15px"
                    >拒绝理由</el-button
                  >
                  <upload1
                    v-if="d.shareSystem == -1 || d.shareSystem == 2"
                    :value="a"
                    limit="1"
                    @input="
                      (e) => {
                        uploadSectionFile(e, d);
                      }
                    "
                    :size="1024 * 1024 * 3"
                    :url="url"
                    :auth="auth"
                    ><el-button type="text" size="small" style="padding: 8px 15px"
                      >重新上传</el-button
                    >
                  </upload1>
                  <el-button
                    type="text"
                    v-if="
                      userModule.roles.filter((el) =>
                        [
                          'ClassManager',
                          'Guardian',
                          'SchoolManager',
                          'Student',
                          'Teacher',
                          'TeacherCourse',
                        ].includes(el.id)
                      ).length > 0 && [1, 3, 4].includes(d.fileType)
                    "
                    @click="songyin(d)"
                    size="small"
                    >送印</el-button
                  >
                  <el-button
                    type="text"
                    v-if="d.shareSystem == -1 || d.shareSystem == 2"
                    @click="shanchu(d)"
                    size="small"
                    style="padding: 2px 15px"
                    >删除</el-button
                  >
                </div>
              </li>
            </ul>
            <div class="unusual" v-else>
              <span class="pt320">暂无内容</span>
            </div>
            <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="pages.pageAll"
              :page-size="pages.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="查看拒绝原因" :visible.sync="chakanshow">
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入内容"
        disabled
        v-model="remarkCon"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="chakanshow = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="送印" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="方式">
          <el-radio-group v-model="form.printType">
            <el-radio :label="1">单面打印</el-radio>
            <el-radio :label="2">双面打印</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number
            v-model="form.printNumber"
            :step="1"
            :min="1"
            label="份"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="纸张类型">
          <el-radio-group v-model="form.paperType">
            <el-radio
              :label="paperType.key"
              :key="i"
              v-for="(paperType, i) in conditions.paperTypeList"
              >{{ paperType.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            :rows="5"
            placeholder="请输入内容"
            v-model="form.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="tijiaosongyin">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑属性" :visible.sync="bianjishuxingshow" width="500px">
      <div class="">
        <el-form :model="shuxingshezhi" size="small" label-width="100px">
          <el-form-item label="选择学段">
            <el-select
              v-model="shuxingshezhi.sectionId"
              clearable
              @change="selSection(shuxingshezhi)"
            >
              <el-option
                v-for="item in tree"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择学科">
            <el-select
              v-model="shuxingshezhi.subjectId"
              clearable
              @change="selSubject(shuxingshezhi)"
            >
              <el-option
                v-for="item in shuxingshezhi.sectionId
                  ? tree.filter((el) => el.id == shuxingshezhi.sectionId)[0].children
                  : []"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择目录">
            <el-cascader
              v-model="shuxingshezhi.catalog"
              :key="shuxingshezhi.resourceId"
              :options="
                shuxingshezhi.sectionId && shuxingshezhi.subjectId
                  ? tree
                      .filter((el) => el.id == shuxingshezhi.sectionId)[0]
                      .children.filter((el) => el.id == shuxingshezhi.subjectId)[0]
                      .children
                  : []
              "
              :props="props"
              @change="selCatalog"
            ></el-cascader>
            <!-- {{shuxingshezhi.sectionId && shuxingshezhi.subjectId
                  ? tree
                      .filter((el) => el.id == shuxingshezhi.sectionId)[0]
                      .children.filter((el) => el.id == shuxingshezhi.subjectId)[0]
                      .children
                  : []}} -->
          </el-form-item>
          <el-form-item label="资源类别">
            <el-select v-model="shuxingshezhi.resourceTypeId" clearable>
              <el-option
                v-for="item in conditions.ziyuanleibieList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改文档名称">
            <el-input
              v-model="shuxingshezhi.resourceName"
              placeholder="请输入文档名称"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="bianjishuxingshow = false">取 消</el-button>
        <el-button type="primary" @click="tijiaoshuxing">确 定</el-button>
      </div>
    </el-dialog>

    <!-- <yulan :watchType='watchType' :fileUrl='fileUrl' @watch-type="getWatchType"></yulan> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import upload from "../../mixins/upload";
import yulan from "@/components/yulan";
import yulanmix from "../../mixins/yulan";
import downLoad from "../../mixins/downLoad";
import upload1 from "../../common/upload1";
let id = 0;
export default {
  name: "upload",
  data() {
    return {
      props: {
        value: "id",
        label: "label",
        leaf: "leaf",
        checkStrictly: true,
      },
      chakanshow: false,
      dialogFormVisible: false,
      bianjishuxingshow: false,
      remarkCon: "",
      search: {
        approvalSchoolId: "",
        orgName: "",
        userName: "",
        year: "",
        beginDate: "",
        endDate: "",
        sectionId: "",
        subjectId: "",
        versionId: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        dataId: "",
        chapterId: "",
        resourceTypeId: "",
        fileType: "",
        resourceName: "",
        firstChapterId: "",
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        shareSystem: "",
        recordType: "",
        userId: "",
        favoriteDownUserId: "",
        schoolId: "",
        startTime: "",
        endTime: "",
        page: 1,
        size: 10,
        catalog: [],
      },
      conditions: {
        xuexiaoList: [],
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        banbenList: [],
        ceciList: [],
        zhangjieList: [],
        ziyuanleibieList: [],
        wendangleixingList: [],
        zhuantiList: [],
        paperTypeList: [],
      },
      conditions1: {
        xuexiaoList: [],
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        banbenList: [],
        ceciList: [],
        zhangjieList: [],
        ziyuanleibieList: [],
        wendangleixingList: [],
        zhuantiList: [],
      },
      tableData: [],
      form: {
        id: "",
        resourceId: "",
        printType: 1,
        printNumber: 0,
        remark: "",
        paperType: "",
      },
      shuxingshezhi: {
        id: "",
        fileType: "",
        sectionId: "",
        subjectId: "",
        versionId: "",
        gradeId: "",
        volumeId: "",
        dataId: "",
        resourceTypeId: "",
        firstChapterId: "",
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        catalog: [],
      },
      pages: {
        pageIndex: 1,
        pageAll: 0,
        pageSize: 10,
      },
      tabH: 0,
      watchType: null,
      fileUrl: "",
      uploadUrl: "",
      previewUrl: "",
      chapterData: [],
      sectionData: [],
      shrink: true,
      url: "",
      auth: {},
      tree: [],
    };
  },
  components: { yulan, upload1 },
  mixins: [upload, yulanmix, downLoad],
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 230;
    });
    this.getXueDuan();
    this.getCatalog();
    this.getZiYuanLeiBie();
    this.getWenDangLeixing();
    this.getUploadList();
    this.getPaperType();
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
    this.sectionData = JSON.parse(window.sessionStorage.getItem("sectionData"));
    this.url = window.sessionStorage.getItem("uploadUrl");
    this.auth = {
      clientId: window.sessionStorage.getItem("clientId"),
      token: window.sessionStorage.getItem("token"),
    };
  },
  computed: {
    ...mapState(["userModule"]),
    sectionData1() {
      let a = [];
      if (this.shuxingshezhi.sectionId) {
        a = this.sectionData.filter((el) => el.id == this.shuxingshezhi.sectionId)[0]
          .children;
      } else {
        return [];
      }
      if (this.shuxingshezhi.subjectId) {
        a = a.filter((el) => el.id == this.shuxingshezhi.subjectId)[0].children;
      } else {
        return [];
      }
      if (this.shuxingshezhi.versionId) {
        a = a.filter((el) => el.id == this.shuxingshezhi.versionId)[0].children;
      } else {
        return [];
      }
      if (this.shuxingshezhi.volumeId) {
        a = a.filter((el) => el.id == this.shuxingshezhi.volumeId)[0].children;
      } else {
        return [];
      }
      return a;
    },
  },
  methods: {
    getPaperType() {
      this.$ajax.post("/common/load/paper/type").then((res) => {
        this.conditions.paperTypeList = res;
        this.form.paperType = 1;
      });
    },
    selCatalog(e) {
      if (e.length > 1) {
        let a = this.tree
          .filter((el) => el.id == this.shuxingshezhi.sectionId)[0]
          .children.filter((el) => el.id == this.shuxingshezhi.subjectId)[0]
          .children.filter((el) => el.id == e[0])[0]
          .children.filter((el) => el.id == e[1])[0];
        this.shuxingshezhi.gradeId = a.gradeId;
        this.shuxingshezhi.gradeName = a.gradeName;
      }
      if (e[0]) {
        this.shuxingshezhi.versionId = e[0];
      } else {
        this.shuxingshezhi.versionId = "";
      }
      if (e[1]) {
        this.shuxingshezhi.volumeId = e[1];
      } else {
        this.shuxingshezhi.volumeId = "";
      }
      if (e[2]) {
        this.shuxingshezhi.firstChapterId = e[2];
      } else {
        this.shuxingshezhi.firstChapterId = "";
      }
      if (e[3]) {
        this.shuxingshezhi.secondChapterId = e[3];
      } else {
        this.shuxingshezhi.secondChapterId = "";
      }
      if (e[4]) {
        this.shuxingshezhi.thirdChapterId = e[4];
      } else {
        this.shuxingshezhi.thirdChapterId = "";
      }
      if (e[5]) {
        this.shuxingshezhi.fourthChapterId = e[5];
      } else {
        this.shuxingshezhi.fourthChapterId = "";
      }
    },
    handleChange(e) {
      if (e[0]) {
        this.search.versionId = e[0];
      } else {
        this.search.versionId = "";
      }
      if (e[1]) {
        this.search.volumeId = e[1];
      } else {
        this.search.volumeId = "";
      }
      if (e[2]) {
        this.search.firstChapterId = e[2];
      } else {
        this.search.firstChapterId = "";
      }
      if (e[3]) {
        this.search.secondChapterId = e[3];
      } else {
        this.search.secondChapterId = "";
      }
      if (e[4]) {
        this.search.thirdChapterId = e[4];
      } else {
        this.search.thirdChapterId = "";
      }
      if (e[5]) {
        this.search.fourthChapterId = e[5];
      } else {
        this.search.fourthChapterId = "";
      }
    },
    async uploadSectionFile(params, d) {
      debugger;
      params[0].resourceId = d.resourceId;
      this.$ajax
        .post("/server/resource/center/update", params[0], {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getUploadList();
        });
    },
    hide() {
      this.$refs.video.filter((el) => {
        el.pause();
      });
    },
    selSection(v, r = this.conditions) {
      if (v.catalog) v.catalog = [];
      v.subjectId = "";
      v.versionId = "";
      v.gradeId = "";
      v.volumeId = "";
      v.firstChapterId = "";
      v.secondChapterId = "";
      v.thirdChapterId = "";
      v.fourthChapterId = "";
      this.chapterData = [];
      v.resourceTypeId = "";
      r.xuekeList = [];
      r.banbenList = [];
      r.nianjiList = [];
      r.ceciList = [];
      this.getXueKe(r == this.conditions);
      this.getNianJi(r == this.conditions);
    },
    selSubject(v, r = this.conditions) {
      if (v.catalog) v.catalog = [];
      v.versionId = "";
      v.volumeId = "";
      v.firstChapterId = "";
      v.secondChapterId = "";
      v.thirdChapterId = "";
      v.fourthChapterId = "";
      this.chapterData = [];
      v.resourceTypeId = "";
      r.banbenList = [];
      r.ceciList = [];
      this.getBanben(r == this.conditions);
    },
    selVersion(v, r = this.conditions) {
      v.volumeId = "";
      this.chapterData = [];
      v.resourceTypeId = "";
      r.ceciList = [];
      this.getCeCi(r == this.conditions);
    },
    selGrade(v, r = this.conditions) {},
    selVolume(v, r = this.conditions) {
      this.chapterData = [];
      v.resourceTypeId = "";
    },
    selChapter(v) {
      if (v[0]) this.shuxingshezhi.firstChapterId = v[0];
      if (v[1]) this.shuxingshezhi.secondChapterId = v[1];
      if (v[2]) this.shuxingshezhi.thirdChapterId = v[2];
      if (v[3]) this.shuxingshezhi.fourthChapterId = v[3];
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    // // 预览点击
    // yulan(obg){
    //   if(obg.fileType<4){
    //     this.fileUrl = window.sessionStorage.getItem("previewUrl") + window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else if(obg.fileType==4){
    //     this.fileUrl =  window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else if(obg.fileType==5){
    //     this.fileUrl =  window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else{

    //   }
    // },
    // // 获取子节点返回的查看值
    // getWatchType(event){
    //   console.log(event);
    //   this.watchType = event;
    // },
    // 获取学段
    getXueDuan(v = 0) {
      let urlLink = `/common/catalog/load/section`;
      this.$ajax.post(urlLink).then((res) => {
        this.conditions.xueduanList = res;
        this.conditions1.xueduanList = res;
      });
    },
    getCatalog(v = 0) {
      this.$ajax.post("/common/catalog/load/catalog/tree", {}).then((res) => {
        res.forEach((el) => {
          this.ifLeaf(el);
        });
        this.tree = res;
      });
    },
    ifLeaf(data) {
      if (data.children.length == 0) {
        delete data.children;
      } else {
        data.children.forEach((el) => {
          this.ifLeaf(el);
        });
      }
    },
    // 获取年级
    getNianJi(v = 0) {
      let urlLink = `/common/catalog/load/grade`;
      let param = v ? this.shuxingshezhi : this.search;
      if (!param.sectionId) {
        return false;
      }
      this.$ajax.post(urlLink, param).then((res) => {
        if (v) {
          this.conditions.nianjiList = res;
        } else {
          this.conditions1.nianjiList = res;
        }
      });
    },
    // 获取学科
    getXueKe(v = 0) {
      let urlLink = `/common/catalog/load/subject`;
      let param = v ? this.shuxingshezhi : this.search;
      if (!param.sectionId) {
        return false;
      }
      this.$ajax.post(urlLink, param).then((res) => {
        if (v) {
          this.conditions.xuekeList = res;
        } else {
          this.conditions1.xuekeList = res;
        }
      });
    },
    // 获取版本
    getBanben(v = 0) {
      let urlLink = `/common/catalog/load/version`;
      let param = v ? this.shuxingshezhi : this.search;
      if (!param.subjectId) {
        return false;
      }
      this.$ajax.post(urlLink, param).then((res) => {
        if (v) {
          this.conditions.banbenList = res;
        } else {
          this.conditions1.banbenList = res;
        }
      });
    },
    // 获取册次
    getCeCi(v = 0) {
      let urlLink = `/common/catalog/load/volume`;
      let param = v ? this.shuxingshezhi : this.search;
      if (!param.versionId) {
        return false;
      }
      this.$ajax.post(urlLink, param).then((res) => {
        if (v) {
          this.conditions.ceciList = res;
        } else {
          this.conditions1.ceciList = res;
        }
      });
    },
    // 获取章节
    async getZhangJie(v, r) {
      debugger;
      if (!this.shuxingshezhi.volumeId) {
        return false;
      }
      let urlLink = `/common/catalog/load/chapter`;
      let param = this.shuxingshezhi;
      if (v.level != 0) param.chapterId = v.data.node;
      let a = await this.$ajax.post(urlLink, param);
      a.forEach((el) => {
        el.leaf = v.level == 3 ? true : false;
      });
      r(a);
      // .then((res) => {
      //   console.log("获取章节", res);
      //   this.conditions.zhangjieList = res;
      // });
    },
    // 获取资源类别
    getZiYuanLeiBie() {
      let urlLink = `/common/load/resource/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取资源类别", res);
        this.conditions.ziyuanleibieList = res;
      });
    },
    // 获取文档类型
    getWenDangLeixing() {
      let urlLink = `/common/load/file/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取文档类型", res);
        this.conditions.wendangleixingList = res;
      });
    },
    // 下载按钮
    xiazai(obg) {
      let urlLink = `/server/my/upload/download`;
      let param = { resourceId: obg.resourceId };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("下载返回", res);
        if (res == "操作成功") {
          window.open(this.userModule.uploadUrl + obg.fileUrl);
        }
      });
    },
    // 查看按钮
    chakan(obg) {
      this.chakanshow = true;
      this.remarkCon = obg.refuseCause;
    },
    // 编辑属性
    bianjishuxing(obg) {
      this.shuxingshezhi = obg;
      this.shuxingshezhi.catalog = [];
      // this.chapterData = [];
      if (obg.versionId) this.shuxingshezhi.catalog.push(obg.versionId);
      if (obg.volumeId) this.shuxingshezhi.catalog.push(obg.volumeId);
      if (obg.firstChapterId) this.shuxingshezhi.catalog.push(obg.firstChapterId);
      if (obg.secondChapterId) this.shuxingshezhi.catalog.push(obg.secondChapterId);
      if (obg.thirdChapterId) this.shuxingshezhi.catalog.push(obg.thirdChapterId);
      if (obg.fourthChapterId) this.shuxingshezhi.catalog.push(obg.fourthChapterId);

      this.getXueDuan();
      if (obg.gradeId) this.getNianJi(1);
      if (obg.sectionId) this.getXueKe(1);
      if (obg.subjectId) this.getBanben(1);
      if (obg.versionId) this.getCeCi(1);
      this.bianjishuxingshow = true;

      // this.shuxingshezhi.id = obg.resourceId == null ? "" : obg.resourceId;
      // this.shuxingshezhi.sectionId = obg.sectionId == null ? "" : obg.sectionId;
      // this.shuxingshezhi.fileType = obg.fileType == null ? "" : obg.fileType;
      // this.shuxingshezhi.subjectId = obg.subjectId == null ? "" : obg.subjectId;
      // this.shuxingshezhi.versionId = obg.versionId == null ? "" : obg.versionId;
      // this.shuxingshezhi.gradeId = obg.gradeId == null ? "" : obg.gradeId;
      // this.shuxingshezhi.volumeId = obg.volumeId == null ? "" : obg.volumeId;
      // this.shuxingshezhi.resourceTypeId =
      //   obg.resourceTypeId == null ? "" : obg.resourceTypeId;
      // this.shuxingshezhi.firstChapterId =
      //   obg.firstChapterId == null ? "" : obg.firstChapterId;
    },
    // 提交编辑属性
    tijiaoshuxing() {
      if (!this.shuxingshezhi.sectionId) {
        this.$message.error("学段不可为空");
        return false;
      }
      if (!this.shuxingshezhi.subjectId) {
        this.$message.error("学科不可为空");
        return false;
      }
      if (!this.shuxingshezhi.versionId) {
        this.$message.error("版本不可为空");
        return false;
      }
      if (!this.shuxingshezhi.resourceTypeId) {
        this.$message.error("资源类别不可为空");
        return false;
      }
      if (!this.shuxingshezhi.resourceName) {
        this.$message.error("文档名称不可为空");
        return false;
      }
      let urlLink = `/server/my/upload/editResourceById`;
      this.shuxingshezhi.id = this.shuxingshezhi.resourceId;
      this.$ajax.post(urlLink, this.shuxingshezhi).then((res) => {
        console.log("提交属性返回", res);
        if (res == "操作成功") {
          this.$message({
            message: "属性提交成功！",
            type: "success",
          });
          this.bianjishuxingshow = false;
          this.search.sectionId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.getUploadList();
        }
      });
    },
    // 删除
    shanchu(obg) {
      this.$confirm("请确认是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let urlLink = `/server/my/upload/delete`;
          let param = { resourceId: obg.resourceId };
          this.$ajax.post(urlLink, param).then((res) => {
            console.log("删除返回", res);
            if (res == "操作成功") {
              this.$message({
                message: "删除成功！",
                type: "success",
              });
              this.getUploadList();
            }
          });
        })
        .catch(() => {});
    },
    // 送印
    songyin(obg) {
      if (obg.shareSystem == -1) {
        this.$alert("共享后允许送印", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        this.$confirm("共享后允许送印, 是否立刻共享?", "提示", {
          confirmButtonText: "共享",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.gongxiang(obg);
          })
          .catch(() => {});
      } else {
        this.dialogFormVisible = true;
        this.form.resourceId = obg.resourceId;
        this.id = "";
        this.form.printType = 2;
        this.form.printNumber = "";
        this.form.remark = "";
      }
    },
    // 提交送印
    tijiaosongyin() {
      let urlLink = `/server/my/upload/printResourceById `;
      this.$ajax.post(urlLink, this.form).then((res) => {
        console.log("送印资源返回", res);
        if (res == "操作成功") {
          this.$message({
            message: "送印成功",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.getUploadList();
        }
      });
    },
    // c重新上传
    chongxinshangchuan(obg) {
      let urlLink = `/server/resource/center/deleteById`;
      let param = { resourceId: obg.resourceId };
      this.$ajax.post(urlLink, param).then((res) => {
        this.$router.push({ name: "resourceUpload" });
      });
    },
    // 共享按钮
    gongxiang(obg) {
      let urlLink = `/server/my/upload/share`;
      let param = { resourceId: obg.resourceId };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("共享返回", res);
        if (res == "操作成功") {
          this.$message({
            message: "共享成功!",
            type: "success",
          });
          this.getUploadList();
        }
      });
    },
    // 获取我的上传列表
    getUploadList() {
      let urlLink = `/server/my/upload/load/list`;
      this.$ajax.post(urlLink, this.search).then((res) => {
        console.log("获取我的上传列表", res);
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
    },
    // 分页切换
    handleCurrentChange(v) {
      this.search.page = v;
      this.getUploadList();
    },
    handleSizeChange(v) {
      this.search.page = 1;
      this.search.size = v;
      this.getUploadList();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/my/upload.vue